export default function makeNoDataRGB(noDataValue) {
  // typescript not smart enough to realize all values in the array will be the same
  // @ts-ignore
  return [noDataValue, noDataValue, noDataValue];
}